import React from "react";
import Button from "../../components/CustomButtons/Button.js";
import saveAsPDF from "../../components/SaveResults/SaveAsPDF";

const SaveResultsButton = ({ tableData, inputData, criteriaSelected, alternativesNames }) => {
  const handleSavePDF = () => {
    saveAsPDF(tableData, inputData, criteriaSelected, alternativesNames);
  };

  return (
    <div>
      <Button onPress={handleSavePDF}>Sačuvaj kao PDF</Button>
    </div>
  );
};

export default SaveResultsButton;

